import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';
import Contact from './pages/Contact/Contact';
import CaseStudies from './pages/CaseStudies/CaseStudies';
import NotFound from './pages/NotFound/NotFound';
import { routeSegments, Language } from './routes/routeConfig';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          {(Object.keys(routeSegments) as Language[]).map((lang) => {
            const segs = routeSegments[lang];
            return (
              <React.Fragment key={lang}>
                <Route path={segs.about} element={<About />} />
                <Route path={segs.services} element={<Services />} />
                <Route path={`${segs.services}/:slug`} element={<ServiceDetail />} />
                <Route path={`${segs.services}/:slug/${segs.caseStudies}`} element={<CaseStudies />} />
                <Route path={segs.contact} element={<Contact />} />
              </React.Fragment>
            );
          })}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
